const translations = {
  "Manage subscription": {
    en: "Manage subscription",
    es: 'Administrar suscripción',
    pt: 'Gerenciar assinatura',
  },
  "Payment pending": {
    en: "Payment pending",
    es: "Pago pendiente",
    pt: "Pagamento pendente",
  },
  "Settle payment": {
    en: "Settle payment",
    es: "Regularizar",
    pt: "Regularizar",
  },
  "Account": {
    en: "Account",
    es: "Cuenta",
    pt: "Conta",
  },
  "Plan": {
    en: "Plan",
    es: "Plan",
    pt: "Plano",
  },
  "Payment": {
    en: "Payment",
    es: "Pago",
    pt: "Pagamento",
  },
  "Monthly": {
    en: "Monthly",
    es: "Mensual",
    pt: "Mensal",
  },
  "months": {
    en: "months",
    es: "meses",
    pt: "meses",
  },
  "Yearly": {
    en: "Yearly",
    es: "Anual",
    pt: "Anual",
  },
  "years": {
    en: "years",
    es: "años",
    pt: "anos",
  },
  "Weekly": {
    en: "Weekly",
    es: "Semanal",
    pt: "Semanal",
  },
  "weeks": {
    en: "weeks",
    es: "semanas",
    pt: "semanas",
  },
  "days": {
    en: "days",
    es: "días",
    pt: "dias",
  },
  "Daily": {
    en: "Daily",
    es: "Diario",
    pt: "Diário",
  },
  "month": {
    en: "Month",
    es: "Mes",
    pt: "Mês",
  },
  "year": {
    en: "Year",
    es: "Año",
    pt: "Ano",
  },
  "week": {
    en: "Week",
    es: "Semana",
    pt: "Semana",
  },
  "day": {
    en: "Day",
    es: "Día",
    pt: "Dia",
  },
  'Select plan': {
    en: "Select plan",
    es: "Seleccionar plan",
    pt: "Selecionar plano",
  },
  'Select event': {
    en: "Select event",
    es: "Seleccionar evento",
    pt: "Selecionar evento",
  },
  'Owned': {
    en: "Owned",
    es: "Comprado",
    pt: "Comprado",
  },
  'Current plan': {
    en: "Current plan",
    es: "Plan actual",
    pt: "Plano atual",
  },
  'Change product': {
    en: "Change product",
    es: "Cambiar producto",
    pt: "Mudar produto",
  },
  'Total due': {
    en: "Total due",
    es: "Total a pagar",
    pt: "Total a pagar",
  },
  'Discount': {
    en: "Discount",
    es: "Descuento",
    pt: "Desconto",
  },
  'No coupon has been applied': {
    en: "No coupon has been applied",
    es: "No se ha aplicado ningún cupón",
    pt: "Nenhum cupom foi aplicado",
  },
  'Pay each': {
    en: "Pay each",
    es: "Paga cada",
    pt: "Paga cada",
  },
  'Renewal': {
    en: "Renewal",
    es: "Renovación",
    pt: "Renovação",
  },
  'Your ticket is available already!': {
    en: "Your ticket is available already!",
    es: "¡Tu entrada ya está disponible!",
    pt: "O seu ingresso está disponível!",
  },
  'There are no plans available for this category at this time': {
    en: "There are no plans available for this category at this time",
    es: "No hay planes disponibles para esta categoría en este momento",
    pt: "Não há planos disponíveis para esta categoria neste momento",
  },
  'Payment Information': {
    en: "Payment information",
    es: "Datos de la tarjeta",
    pt: "Dados da tarjeta",
  },
  'Billing Information': {
    en: "Billing information",
    es: "Datos de facturación",
    pt: "Dados de faturamento",
  },
  'Address': {
    en: "Address",
    es: "Dirección",
    pt: "Endereço",
  },
  'Address 2': {
    en: "Address 2",
    es: "Dirección 2",
    pt: "Endereço 2",
  },
  'Country': {
    en: "Country",
    es: "País",
    pt: "País",
  },
  'City': {
    en: "City",
    es: "Ciudad",
    pt: "Cidade",
  },
  'Postal code': {
    en: "Postal Code",
    es: "Código postal",
    pt: "Código postal",
  },
  'First name': {
    en: "First name",
    es: "Nombre",
    pt: "Nome",
  },
  'Card number': {
    en: "Card number",
    es: "Número de tarjeta",
    pt: "Número da tarjeta",
  },
  'Expire date': {
    en: "Expire date",
    es: "Fecha de vencimiento",
    pt: "Data de vencimento",
  },
  'CVV': {
    en: "CVV",
    es: "CVV",
    pt: "CVV",
  },
  'Promotional code': {
    en: "Promotional code",
    es: "Código promocional",
    pt: "Código promocional",
  },
  'Enter your promotional code': {
    en: "Enter your promotional code",
    es: "Ingresa tu código promocional",
    pt: "Digite seu código promocional",
  },
  'Pay': {
    en: "Pay",
    es: "Pagar",
    pt: "Pagar",
  },
  '_payment_recaptcha_notice_1_': {
    en: "This site is protected by reCAPTCHA and the Google",
    es: "Este sitio está protegido por reCAPTCHA y la",
    pt: "Este site é protegido pelo reCAPTCHA e pelo Google",
  },
  '_payment_recaptcha_notice_2_': {
    en: "and",
    es: "y",
    pt: "e",
  },
  '_payment_recaptcha_notice_3_': {
    en: "apply",
    es: "de Google aplican",
    pt: "aplicam",
  },
  'Billing information updated successfully': {
    en: "Billing information updated successfully",
    es: "Datos de la tarjeta actualizados correctamente",
    pt: "Informação de faturamento atualizada com sucesso",
  },
  'Select your plan': {
    en: "Select your plan",
    es: "Selecciona tu plan",
    pt: "Selecione seu plano",
  },
  'Pay securely': {
    en: "Pay securely",
    es: "Pagar de forma segura",
    pt: "Pagar com segurança",
  },
  'Processing': {
    en: "Processing",
    es: "Procesando",
    pt: "Processando",
  },
  'You\'ve selected': {
    en: "You've selected",
    es: "Has seleccionado",
    pt: "Você selecionou",
  },
  'Free': {
    en: "Free",
    es: "Gratis",
    pt: "Grátis",
  },
  'then': {
    en: "then",
    es: "luego",
    pt: "depois",
  },
  '{trialValue} {trialPeriod} free, then {priceCurrency} {priceValue}/{productPeriod}': {
    en: "{trialValue} {trialPeriod} free, then {priceCurrency} {priceValue}/{productPeriod}",
    es: "{trialValue} {trialPeriod} gratis, luego {priceCurrency} {priceValue}/{productPeriod}",
    pt: "{trialValue} {trialPeriod} grátis, então {priceCurrency} {priceValue}/{productPeriod}",
  },
  'I want it!': {
    en: "I want it!",
    es: "¡Lo quiero!",
    pt: "Quero isso!"
  },
  'There is a special offer for you!': {
    en: "There is a special offer for you!",
    es: "¡Hay una oferta especial para ti!",
    pt: "Há uma oferta especial para você!"
  },
  'Cash / Transfer': {
    en: 'Cash / Transfer',
    es: 'Efectivo / Transferencia',
    pt: 'Dinheiro / Transferência'
  },
  'Pay with': {
    en: 'Pay with',
    es: 'Pagar con',
    pt: 'Pague com'
  },
  'We have successfully generated your payment link, proceed to make the payment before: {orderExpireDate}': {
    en: 'We have successfully generated your payment link, proceed to make the payment before: {orderExpireDate}',
    es: 'Hemos generado correctamente tu enlace de pago, procede a realizar el pago antes de: {orderExpireDate}',
    pt: 'Geramos com sucesso seu link de pagamento, proceda para fazer o pagamento antes: {orderExpireDate}',
  },
  'Redirecting to the payment link...': {
    en: 'Redirecting to the payment link...',
    es: 'Redirigiendo al enlace de pago...',
    pt: 'Redirecionando para o link de pagamento...'
  },
  "Go to pay now": {
    en: "Go to pay now",
    es: "Ir a pagar ahora",
    pt: "Ir agora para pagar"
  },
  'Pay securely now': {
    en: 'Pay securely now',
    es: 'Pagar de forma segura',
    pt: 'Pague com segurança'
  },
  'Select payment method': {
    en: 'Select payment method',
    es: 'Seleccionar método de pago',
    pt: 'Selecione o método de pagamento'
  },
  'Select the payment method you want to use to pay for this product': {
    en: 'Select the payment method you want to use to pay for this product',
    es: 'Selecciona el método de pago que deseas utilizar para pagar este producto.',
    pt: 'Selecione o método de pagamento que deseja utilizar para pagar este produto'
  },
  'renewable': {
    en: 'renewable',
    es: 'renovable',
    pt: 'renovável'
  },
  'Street and number': {
    en: 'Street and number',
    es: 'Calle y número',
    pt: 'Rua e número'
  },
  'Apartment, building, floor': {
    en: 'Apartment, building, floor',
    es: 'Apartamento, edificio, piso',
    pt: 'Apartamento, prédio, andar'
  },
  "Download the app": {
    en: "Download the app",
    es: "Descarga la app",
    pt: "Baixar o aplicativo"
  },
  'Expire date (MM//YY)':{
    en: 'Expire date (MM//YY)',
    es: 'Fecha de vencimiento (MM/AA)',
    pt: 'Data de validade (MM/AA)'
  },
  'Thanks for confirming your payment method! You’re all set to continue': {
    en: 'Thanks for confirming your payment method! You’re all set to continue',
    es: '¡Gracias por confirmar tu método de pago! Ya está todo listo para continuar.',
    pt: 'Obrigado por confirmar seu método de pagamento! Você está pronto para continuar'
  },
  'Please allow pop-up windows in your browser and try again': {
    en: 'Please allow pop-up windows in your browser and try again',
    es: 'Habilita las ventanas emergentes en tu navegador e intenta de nuevo',
    pt: 'Habilite as janelas pop-up no seu navegador e tente novamente'
  },
  'Thanks for confirming your payment method!': {
    en: 'Thanks for confirming your payment method!',
    es: '¡Gracias por confirmar tu método de pago!',
    pt: 'Obrigado por confirmar seu método de pagamento!'
  },
  'Your payment method update is in progress. Please confirm the transaction to continue': {
    en: 'Your payment method update is in progress. Please confirm the transaction to continue',
    es: 'La actualización de tu método de pago está en curso. Confirma la transacción para continuar',
    pt: 'A atualização do seu método de pagamento está em andamento. Confirme a transação para continuar'
  },
  'An error has occurred while updating the subscription': {
    en: 'An error has occurred while updating the subscription',
    es: 'Ha ocurrido un error al actualizar la suscripción',
    pt: 'Ocorreu um erro ao atualizar a assinatura'
  },
  'Your subscription has been successfully updated': {
    en: 'Your subscription has been successfully updated',
    es: 'Tu suscripción ha sido actualizada con éxito',
    pt: 'Sua assinatura foi atualizada com sucesso'
  },
  'Cardholder Name': {
    en: 'Cardholder Name',
    es: 'Nombre del titular de la tarjeta',
    pt: 'Nome do titular do cartão'
  },
  'Card Information': {
    en: 'Card Information',
    es: 'Información de la tarjeta',
    pt: 'Informações do cartão'
  },
  'Credit / Debit card': {
    en: 'Credit / Debit card',
    es: 'Tarjeta de Crédito / Débito',
    pt: 'Cartão de Crédito / Débito'
  },
  'Other payment method': {
    en: 'Other payment method',
    es: 'Otro método de pago',
    pt: 'Outro meio de pagamento'
  },
  'Yape': {
    en: 'Yape',
    es: 'Yape',
    pt: 'Yape'
  },
  'Address is required': {
    en: 'Address is required',
    es: 'La dirección es obligatoria',
    pt: 'O endereço é obrigatório'
  },
  'Country is required': {
    en: 'Country is required',
    es: 'El país es obligatorio',
    pt: 'O país é obrigatório'
  },
  'City is required': {
    en: 'City is required',
    es: 'La ciudad es obligatoria',
    pt: 'A cidade é obrigatória'
  },
  'Postal code is required': {
    en: 'Postal code is required',
    es: 'El código postal es obligatorio',
    pt: 'O código postal é obrigatório'
  },
  'Card number is required': {
    en: 'Card number is required',
    es: 'El número de tarjeta es obligatorio',
    pt: 'O número do cartão é obrigatório'
  },
  'One payment': {
    en: 'One payment',
    es: 'Un pago',
    pt: 'Um pagamento'
  },
  'One-time payment': {
    en: 'One-time payment',
    es: 'Pago único',
    pt: 'Pagamento único'
  },
  'Valid for 1 month': {
    en: 'Valid for 1 month',
    es: 'Válido por 1 mes',
    pt: 'Válido por 1 mês'
  },
  'Valid for {amount} months': {
    en: 'Valid for {amount} months',
    es: 'Válido por {amount} meses',
    pt: 'Válido por {amount} meses'
  },
  'forever': {
    en: 'forever',
    es: 'para siempre',
    pt: 'para sempre'
  },
}

export default translations